module.exports = __webpack_public_path__ + "static/media/bakingDessertItems.8a4ab002.webp";